import { application } from "./application"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const context = require.context("controllers", true, /.js$/)
application.load(definitionsFromContext(context))

import { Autocomplete } from 'stimulus-autocomplete'
application.register('autocomplete', Autocomplete)

import TextareaAutogrow from 'stimulus-textarea-autogrow'
application.register('textarea-autogrow', TextareaAutogrow)
